import { wrapper } from '@/redux/store';
import { withAuthentication } from '@/src/core/utils/authentication';
import PopupManager from '@/src/core/components/PopupManager';
import { withReactDetectDevice } from '@/src/core/utils/ssr/withDetectDevice';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { getDynamicInfoForVideoLandingPage } from '@/features/geovideo';
import { getIp } from '@/src/shared/utils/ssr/getIp';
import { GeoLocationResult } from '@/src/containers/Landings/utils/geoVideo/types';
import { LandingProvider } from '@/src/containers/Landings/LandingProvider/LandingProvider';

import Footer from '@/src/containers/Landings/Footer';

import HomeContent from '@/src/containers/Home';

type Props = GeoLocationResult;

function HomePage({
  usersCount,
  video,
  regions,
  detectedRegion,
  default_region_name,
  ip_location_details,
  ...props
}: Props) {
  return (
    <>
      <LandingProvider>
        <HomeContent
          {...props}
          usersCount={usersCount}
          video={video}
          regions={regions}
          detectedRegion={detectedRegion}
          default_region_name={default_region_name}
          ip_location_details={ip_location_details}
        />
      </LandingProvider>

      <Footer />
      <PopupManager />
    </>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  withAuthentication(
    store,
    withReactDetectDevice(store, async ({ req, query }) => {
      const queryClient = new QueryClient();

      const [dynamicInfo] = await Promise.all([
        getDynamicInfoForVideoLandingPage({
          ...query,
          ip: getIp({ req, query }),
        }),
      ]);

      return {
        props: {
          usersCount: dynamicInfo?.usersCount,
          video: dynamicInfo?.video,
          regions: dynamicInfo?.regions,
          detectedRegion: dynamicInfo?.detectedRegion,
          default_region_name: dynamicInfo?.default_region_name,
          ip_location_details: dynamicInfo?.ip_location_details,
          default_region_title: dynamicInfo?.default_region_title,
          dehydratedState: dehydrate(queryClient),
        },
      };
    }),
    { dontRedirectToLoginPage: true }
  )
);

HomePage.pageName = 'home_page';
HomePage.withIntercomChatBot = true;

export default HomePage;
